import React, { Component } from 'react';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { CodetableListComponentProps } from './types';
import { MergeCodeContainer } from 'app/area/codetable/common/merge-code/merge-code-container';
import {
  DefaultCodetableListContent
} from 'app/area/codetable/list/list-items/default-codetable-list-content';
import { CodetableListDragPreview } from 'app/area/codetable/list/list-items/drag-and-drop/codetable-drag-preview';

export class DefaultCodetableListComponent extends Component<CodetableListComponentProps> {
  public render() {

    return <SearchFilters {...this.props}>
      {this.props.isHierarchyMode
        ? <CodetableListDragPreview {...this.props} wrappedComponent={DefaultCodetableListContent} />
        : <DefaultCodetableListContent {...this.props} />}
      <MergeCodeContainer {...this.props} />
    </SearchFilters>;
  }
}
